<template>
  <div style="width: 100%">
    <ion-grid>
      <ion-row justify-content-center>
        <ion-col align-self-center size-md="5" size-lg="5" size-xs="12">
          <div style="margin: 2em 0 1em; width: 100%;" text-center>
            <!-- <img src="http://placehold.it/300x200" /> -->
            <img src="img/lawyerly-invert.logo.png" style="width: 80%; margin: auto;" />
            <!-- <h4>Login Form</h4> -->
          </div>
          <div padding>
            <ion-item>
              <ion-input
                v-ion-model="email"
                type="text"
                placeholder="Email"
              ></ion-input>
            </ion-item>

            <ion-item>
              <ion-input
                v-ion-model="password"
                type="password"
                placeholder="Password"
              ></ion-input>
            </ion-item>
          </div>


          <div v-if="isLoading" padding  class="center-content" style="min-height: 290px;">
            <ion-spinner color="primary"></ion-spinner>
            <p>Logging In...</p>
          </div>
          <div v-else>
            <div padding>
              <ion-button @click="login" expand="block">Login</ion-button>
            </div>
            <div padding class="center-content">
              <!-- FACEBOOK -->
              <!-- <a
                href="#"
                class="sc-btn sc--flat sc--facebook"
                @click.prevent="fbLogin"
              >
                <span class="sc-icon">
                  <svg
                    viewBox="0 0 33 33"
                    width="25"
                    height="25"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g>
                      <path
                        d="M 17.996,32L 12,32 L 12,16 l-4,0 l0-5.514 l 4-0.002l-0.006-3.248C 11.993,2.737, 13.213,0, 18.512,0l 4.412,0 l0,5.515 l-2.757,0 c-2.063,0-2.163,0.77-2.163,2.209l-0.008,2.76l 4.959,0 l-0.585,5.514L 18,16L 17.996,32z"
                      ></path>
                    </g>
                  </svg>
                </span>
                <span class="sc-text">
                  Login with Facebook
                </span>
              </a> -->

              <!-- GOOGLE PLUS -->
              <!-- <a
                href="#"
                class="sc-btn sc--flat sc--google-plus"
                @click.prevent="ggLogin"
              >
                <span class="sc-icon">
                  <svg
                    viewBox="0 0 33 33"
                    width="25"
                    height="25"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g>
                      <path
                        d="M 17.471,2c0,0-6.28,0-8.373,0C 5.344,2, 1.811,4.844, 1.811,8.138c0,3.366, 2.559,6.083, 6.378,6.083 c 0.266,0, 0.524-0.005, 0.776-0.024c-0.248,0.475-0.425,1.009-0.425,1.564c0,0.936, 0.503,1.694, 1.14,2.313 c-0.481,0-0.945,0.014-1.452,0.014C 3.579,18.089,0,21.050,0,24.121c0,3.024, 3.923,4.916, 8.573,4.916 c 5.301,0, 8.228-3.008, 8.228-6.032c0-2.425-0.716-3.877-2.928-5.442c-0.757-0.536-2.204-1.839-2.204-2.604 c0-0.897, 0.256-1.34, 1.607-2.395c 1.385-1.082, 2.365-2.603, 2.365-4.372c0-2.106-0.938-4.159-2.699-4.837l 2.655,0 L 17.471,2z M 14.546,22.483c 0.066,0.28, 0.103,0.569, 0.103,0.863c0,2.444-1.575,4.353-6.093,4.353 c-3.214,0-5.535-2.034-5.535-4.478c0-2.395, 2.879-4.389, 6.093-4.354c 0.75,0.008, 1.449,0.129, 2.083,0.334 C 12.942,20.415, 14.193,21.101, 14.546,22.483z M 9.401,13.368c-2.157-0.065-4.207-2.413-4.58-5.246 c-0.372-2.833, 1.074-5.001, 3.231-4.937c 2.157,0.065, 4.207,2.338, 4.58,5.171 C 13.004,11.189, 11.557,13.433, 9.401,13.368zM 26,8L 26,2L 24,2L 24,8L 18,8L 18,10L 24,10L 24,16L 26,16L 26,10L 32,10L 32,8 z"
                      ></path>
                    </g>
                  </svg>
                </span>
                <span class="sc-text">
                  Login with Google+
                </span>
              </a> -->

              <a href="#" @click.prevent="ggLogin" :class="`google-btn ${this.$store.state.settings.settings.theme}`">
                <div class="google-icon-wrapper">
                  <img class="google-icon" :src="glogo"/>
                </div>
                <p class="btn-text"><b>Sign in with Google</b></p>
              </a>
              <br />
              <div padding>
                <!-- <a @click.prevent="$router.push('/profile/register')"> -->
                <span>Don't have Google account?</span><br/>
                <a style="text-decoration: none; display: block; padding-top: 10px;" href="#" @click.prevent="$router.push('/profile/register')">
                  Register with my email
                </a>
              </div>
              <div padding>
                <!-- <a @click.prevent="$router.push('/profile/forget')"> -->
                <a style="text-decoration: none;" href="#" @click.prevent="$router.push('/profile/forget')">
                Forget your password?
                </a>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>
<script>
// import { firebase_mixin } from "@/firebase";
import { firebase as $firebase } from "@/firebase";

import glogo from "@/assets/glogo.svg";
import glogodark from "@/assets/glogo_dark.svg";

export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      toastTimeout: 2000,
      isLoading: true,
      // glogo: this.$store.state.settings.settings.theme
    };
  },

  computed: {
    glogo() {
      if(this.$store.state.settings.settings.theme == "dark") {
        return glogodark;
      }
      return glogo;
    }
  },

  methods: {
    async checkRedirect() {

      /* verify token */
      await $firebase
        .auth()
        .getRedirectResult()
        .then(this.verifyToken)
        .then(res => {
          const user = res.data;
          if (user.email) {
            user["login_at"] = new Date();
            //console.log(user);
            this.$store.commit("user/setUser", user);
            if(user.subscription) {
              this.$router.replace("/");
              return;
            }

            this.$router.replace("/subscribe");
            return;
          }

          this.$ionic.showToast(`Something went wrong. Please try again.`, { duration: this.toastTimeout });
        })
        .catch(error => {
          if (!error) {
            return;
          }
          // Handle Errors here.
          // var errorCode = error.code
          var errorMessage = error.message;
          this.$ionic.showToast(errorMessage, { duration: this.toastTimeout });
        });

        await this.$ionic.dismissLoading();
        this.isLoading = false;
    },

    async verifyToken(result) {
      var currentUser = $firebase.auth().currentUser;

      if (!currentUser) {
        return Promise.reject(null);
      }

      let _token = null;
      return currentUser
        .getIdToken(/* forceRefresh */ true)
        .then(async idToken => {
          // this.$store.commit("user/setToken", idToken);
          this.token = idToken;

          //verify firebase token on server
          const res = await this.$http.get(this.$config.api.url + "/fauth", {headers: { "Authorization": "Bearer "  + idToken }});

          //set server token
          _token = res.data;
          this.$http.defaults.headers.common["Authorization"] =
          "Bearer " + _token;
          this.$store.commit("user/setToken", _token);
        })
        .then(() => {
          return this.$http.get(this.$config.api.url + "/auth/me");
        });
    },

    login() {
      if (this.email.length < 4 || !this.validateEmail(this.email)) {
        this.$ionic.showToast("Please enter a valid email address", {
          duration: this.toastTimeout
        });
        return;
      }
      if (this.password.length === 0) {
        this.$ionic.showToast("Please enter a password", {
          duration: this.toastTimeout
        });
        return;
      }

      this.isLoading = true;

      $firebase
        .auth()
        .setPersistence($firebase.auth.Auth.Persistence.LOCAL)
        .then(() =>
          $firebase
            .auth()
            .signInWithEmailAndPassword(this.email, this.password)
        )
        .then(this.verifyToken)
        .then(res => {
          this.checkRedirect();
        })
        .catch(error => {
          if (!error) {
            return;
          }

          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
          if (errorCode === "auth/wrong-password") {
            this.$ionic.showToast("Email/Password is incorrect.", {
              duration: this.toastTimeout
            });
          } else {
            this.$ionic.showToast(errorMessage, {
              duration: this.toastTimeout
            });
          }
        });
    },

    async _socialLogin(provider) {
      return $firebase
        .auth()
        .setPersistence($firebase.auth.Auth.Persistence.LOCAL)
        // .then(() => $firebase.auth().signInWithRedirect(provider))
        .then(() => $firebase.auth().signInWithPopup(provider))
        .then(() => {
          return $firebase.auth().getRedirectResult();
        })
        .then(result => {
          this.checkRedirect();
        })
        .catch(error => {
          if (!error) {
            return;
          }
          // Handle Errors here.
          // var errorCode = error.code
          var errorMessage = error.message;
          this.$ionic.showToast(errorMessage, { duration: this.toastTimeout });
        });
    },

    ggLogin(_provider) {
      this.isLoading = true;
      const provider = new $firebase.auth.GoogleAuthProvider();
      // provider.addScope("https://www.googleapis.com/auth/contacts.readonly");
      provider.addScope("https://www.googleapis.com/auth/userinfo.email");
      provider.addScope("https://www.googleapis.com/auth/userinfo.profile");
      this._socialLogin(provider);
    },

    fbLogin() {
      this.isLoading = true;
      const provider = new $firebase.auth.FacebookAuthProvider();
      this._socialLogin(provider);
    },

    validateEmail(email) {
      /* eslint-disable no-useless-escape */
      var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(String(email).toLowerCase());
    },

    back() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.checkRedirect();
  }
};
</script>

<style lang="scss" scoped>
// @import "./profile.scss";

ion-spinner {
  width: 3em;
  height: 3em;
}

.center-content {
  text-align: center;
}

ion-grid {
    width:100%;
    height: 100%;
    --background: #dfdfdf;
}

ion-row {
    height: 100%;
}

ion-button {
    font-weight: 300;
}

@media (min-width: 240px) and (max-width: 768px) {
    ion-col {
        border: none;
    }
}

$white: #fff;
$google-blue: #4285f4;
$button-active-blue: #1669F2;

.google-btn.dark {
  background-color: $google-blue;

  .btn-text {
    color: $white;
  }

  .google-icon-wrapper {
    background-color: $google-blue;
  }
}

.google-btn {
  display: block;
  width: 184px;
  height: 42px;
  border-radius: 2px;
  box-shadow: 0 1px 1px 0 rgba(0,0,0,0.25);
  margin: auto;
  cursor: pointer;

  .google-icon-wrapper {
    position: absolute;
    margin-top: 1px;
    margin-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: $white;
  }

  .btn-text {
    float: right;
    margin: 11px 11px 0 0;
    color: rgba(0,0,0,0.54);
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Roboto";
    font-weight: 500;
  }
  &:hover {
    box-shadow: 0 0 6px rgba(0,0,0,0.25);
  }
  &:active {
    background: $button-active-blue;
  }
}

</style>
